import PropTypes from 'prop-types';

import cultureProp from 'components/propTypes/cultureProp';
import groundTypeProp from 'components/propTypes/groundType';
import rotationEffectProp from 'components/propTypes/rotationEffect';
import userProp from 'components/propTypes/user';
import groundTypeEffect from 'components/propTypes/groundTypeEffect';

export default PropTypes.shape({
  cultures: PropTypes.arrayOf(cultureProp),
  groundTypeEffects: PropTypes.arrayOf(groundTypeEffect),
  groundTypes: PropTypes.arrayOf(groundTypeProp),
  id: PropTypes.number,
  name: PropTypes.string,
  rotationEffectN1s: PropTypes.arrayOf(rotationEffectProp),
  rotationEffectN2s: PropTypes.arrayOf(rotationEffectProp),
  sectorHasRights: PropTypes.bool,
  sectors: PropTypes.arrayOf(
    PropTypes.shape({
      exploitations: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        })
      ),
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  users: PropTypes.arrayOf(userProp),
});
